import Link from "next/link";
import Image from "next/image";

export function MarketingFooter() {
  return (
    <footer className="bg-[#1c3d51] text-gray-400 py-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-between gap-8">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <Link href="/" className="flex items-center gap-2 min-w-0">
                  <Image
                    src="/hirefitlogo-puzzle-greenmono-rec.png"
                    alt="HireFit Logo"
                    width={1600}
                    height={840}
                    className="h-6 sm:h-7 w-auto shrink-0"
                    priority
                  />
                </Link>
              </div>
              <p className="text-sm">
                A job tracker that fills itself and tells you which jobs you actually fit.
              </p>
            </div>

            <div className="flex flex-wrap gap-10 text-sm">
              <div className="flex flex-col gap-2">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">Company</p>
                <a href="/about" className="hover:text-white transition-colors">About</a>
                <a href="/features" className="hover:text-white transition-colors">Features</a>
                <a href="/contact" className="hover:text-white transition-colors">Contact</a>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">Resources</p>
                <a href="/job-application-tracker" className="hover:text-white transition-colors">Job Application Tracker</a>
                <a href="/resume-job-match-analysis" className="hover:text-white transition-colors">Resume Match Analysis</a>
                <a href="/ats-keyword-analysis" className="hover:text-white transition-colors">ATS Keyword Analysis</a>
                <a href="/cover-letter-generator" className="hover:text-white transition-colors">Cover Letter Generator</a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-6 pt-6 flex items-center justify-between flex-wrap gap-4 text-xs">
            <div className="flex items-center gap-6">
              <p>&copy; 2026 LVII Ltd. Liability Co. d/b/a HireFit. All rights reserved.</p>
              <a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="/terms" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="/privacy#ccpa" className="hover:text-white transition-colors">Do Not Sell or Share My Personal Information</a>
            </div>
          </div>
        </div>
      </footer>
  );
}
